<template>
  <button @click="$emit('click')" v-bind="$attrs">
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0.5C6.19891 0.5 6.38968 0.579018 6.53033 0.71967C6.67098 0.860322 6.75 1.05109 6.75 1.25V5.75H11.25C11.4489 5.75 11.6397 5.82902 11.7803 5.96967C11.921 6.11032 12 6.30109 12 6.5C12 6.69891 11.921 6.88968 11.7803 7.03033C11.6397 7.17098 11.4489 7.25 11.25 7.25H6.75V11.75C6.75 11.9489 6.67098 12.1397 6.53033 12.2803C6.38968 12.421 6.19891 12.5 6 12.5C5.80109 12.5 5.61032 12.421 5.46967 12.2803C5.32902 12.1397 5.25 11.9489 5.25 11.75V7.25H0.75C0.551088 7.25 0.360322 7.17098 0.21967 7.03033C0.0790178 6.88968 0 6.69891 0 6.5C0 6.30109 0.0790178 6.11032 0.21967 5.96967C0.360322 5.82902 0.551088 5.75 0.75 5.75H5.25V1.25C5.25 1.05109 5.32902 0.860322 5.46967 0.71967C5.61032 0.579018 5.80109 0.5 6 0.5V0.5Z" fill="#2591CB"/>
    </svg>
  </button>
</template>

<script>
export default {
  name: "collapse-plus",
}
</script>

<style scoped>
  button:hover{ background: var(--p-blue); }
  button:hover > svg > path {fill: #FFFFFF}
  button {background: transparent; padding: 0;  width: 24px; border: 2px solid var(--p-blue);
    height: 24px; display: flex; align-items: center; justify-content: center; border-radius: 3px; min-width: 24px;}

</style>
